var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['ripple']},[_c('div',{class:_vm.$style['ripple__circle']}),_c('div',{class:[_vm.$style['ripple__circle'], _vm.$style['ripple__inner-circle']]})])}
var staticRenderFns = []

export { render, staticRenderFns }